import { Radio as RadioMantine } from '@mantine/core'
import React, { memo, useCallback, useEffect, useMemo } from 'react'

import Input from '../../../../Mantine/Input'
import Radio from '../../../../Mantine/Radio'

import * as S from './styles'

const InputRadioFilter = ({
  nome,
  localFilters,
  setLocalFilters,
  setErroNosDados
}) => {
  const handleRadioChange = useCallback(
    (value) => {
      setLocalFilters((prev) => ({
        ...prev,
        [nome]: { ...prev[nome], PERIODO: value }
      }))
    },
    [setLocalFilters, nome]
  )

  const handleInputChange = useCallback(
    (campo, value) => {
      if (localFilters[nome]?.[campo] === value) return

      setLocalFilters((prev) => ({
        ...prev,
        [nome]: { ...prev[nome], [campo]: value }
      }))
    },
    [localFilters, setLocalFilters, nome]
  )

  const periodoValue = useMemo(
    () => localFilters[nome]?.PERIODO || '',
    [localFilters, nome]
  )

  const erroMinMaior =
    Number(localFilters[nome]?.MIN) > Number(localFilters[nome]?.MAX)

  useEffect(() => {
    setErroNosDados(erroMinMaior)
  }, [erroMinMaior, setErroNosDados])

  return (
    <S.InputRadioWrapper>
      <RadioMantine.Group
        name={nome}
        value={periodoValue}
        onChange={handleRadioChange}
      >
        <S.InputRadioGrupo>
          <Radio label="No dia" value="dia" />
          <Radio label="No ciclo" value="ciclo" />
        </S.InputRadioGrupo>
      </RadioMantine.Group>
      <S.InputRadioGrupo>
        <Input
          type="number"
          disabled={!periodoValue}
          maxLength={20}
          rightSection={
            nome === 'CONSUMO' && <S.RightSection>MB</S.RightSection>
          }
          error={erroMinMaior}
          placeholder="Min."
          value={localFilters[nome]?.MIN || ''}
          onChange={(e) => handleInputChange('MIN', e.target.value)}
        />
        <Input
          type="number"
          disabled={!periodoValue}
          maxLength={20}
          rightSection={
            nome === 'CONSUMO' && <S.RightSection>MB</S.RightSection>
          }
          error={erroMinMaior}
          value={localFilters[nome]?.MAX || ''}
          placeholder="Max."
          onChange={(e) => handleInputChange('MAX', e.target.value)}
        />
        {erroMinMaior && <S.Erro>Valor Máx. deve ser maior que Min.</S.Erro>}
      </S.InputRadioGrupo>
    </S.InputRadioWrapper>
  )
}

export default memo(InputRadioFilter)
